import httpClient from "@/plugins/axios";

export const getBenefits = async () => {
    const response = await httpClient.get('/v1/benefits/');
    return response;
}
